<script lang="jsx">
  import { defineComponent, h } from 'vue';
  import { ElSubMenu, ElMenuItem } from 'element-plus';

  const SideMenu = defineComponent({
    name: 'SideMenu',
    props: {
      menus: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    setup(props) {
      // setup是一个函数, 让这个函数再返回一个函数
      return () => {
        return props.menus.map(item => {
          if (item.children && item.children.length > 0) {
            return h(
              ElSubMenu,
              {
                index: item.id
              },
              {
                title: () => {
                  return h('span', {}, item.title);
                },
                default: () => {
                  return h(SideMenu, {
                    menus: item.children
                  });
                }
              }
            );
          } else {
            return h(
              ElMenuItem,
              {
                index: item.id
              },
              {
                title: () => {
                  return h('span', {}, item.title);
                }
              }
            );
          }
        });
      };
    }
  });

  export default SideMenu;
</script>
